import { Box, Chip, Divider, List, ListItem, Theme, useMediaQuery } from '@mui/material';
import { DateRange, PickersShortcuts, PickersShortcutsProps, useIsValidValue, usePickerActionsContext } from '@mui/x-date-pickers-pro';
import { Dayjs } from 'dayjs';

/**
 * Customer Range Shortcuts component for the MUI Date Range Picker to allow our mobile resolutions
 * to render a Horizontal list instead of the default vertical list.
 */
export default function CustomRangeShortcuts<T extends Dayjs>(props: PickersShortcutsProps<DateRange<T>>) {
	const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
	const { items } = props;
	const { setValue } = usePickerActionsContext<DateRange<T>>();
	const isValidValue = useIsValidValue();

	if (items == null || items.length === 0) {
		return null;
	}

	const resolvedItems = items.map((item) => {
		const newValue = item.getValue({ isValid: isValidValue });

		return {
			label: item.label,
			onClick: () => {
				setValue(newValue, {
					changeImportance: 'accept',
					shortcut: item
				});
			},
			disabled: !isValidValue(newValue)
		};
	});

	/**
	 * In Mobile Resolutions we want the list to
	 */
	if (isMobile) {
		return (
			<Box
				sx={{
					gridRow: 1,
					gridColumn: 2
				}}
			>
				<List
					dense
					sx={(theme) => ({
						display: 'flex',
						px: theme.spacing(4),
						'& .MuiListItem-root': {
							pt: 0,
							pl: 0,
							pr: theme.spacing(1)
						}
					})}
				>
					{resolvedItems.map((item) => {
						return (
							<ListItem key={item.label}>
								<Chip {...item} />
							</ListItem>
						);
					})}
				</List>
				<Divider />
			</Box>
		);
	}

	return <PickersShortcuts {...props} />;
}
